module.exports = __webpack_public_path__ + "img/img_six_cont1.4e4a6ad3.png";